const urlMap = {
  dev: 'http://dev.api.iam.beefinx.cn:9009',
  devdev: 'http://dev.api.iam.beefinx.cn',
  test: 'http://test.api.iam.beefinx.cn',
  prod: 'https://api.iam.beefinx.com',
  pre: 'https://pre.api.iam.beefinx.net'
}
let k
let env = process.env.NODE_ENV
let mode = process.env.VUE_APP_MODE
if (env === 'development') {
  if (mode === 'test') {
    k = 'test'
  } else {
    k = 'dev'
  }
} else {
  k = mode
}
const baseUrl = urlMap[k]

export default {
  ROUTE_TYPE: 'history',
  HTTP_CONFIG: {
    timeout: 6000,
    withCredentials: true,
    baseURL: baseUrl,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'Plat-Code': 'IAM'
    }
  },
  HOME_NAME: 'home',
  baseRoutersPath: ['/', '/Login'],
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: 'beefinx-iam',
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,
  /**
   * @description logger color
   */
  stylesheet: {
    info: ['color: blue'],
    log: ['color: green'],
    debug: ['color: black'],
    warn: ['color: #C8CB41'],
    error: ['color: red']
  },
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  },
  /**
   * @description iView全局配置
   */
  iViewConfig: {
    transfer: true
  },
  /**
   * @description 系统分页器原型
   */
  page: {
    pageSize: 10,
    pageNum: 1,
    total: 0
  }
}
